import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    CreateOrderSparkPayload,
    CreateSenderSparkPayload,
    GetCitiesParams,
    GetCitiesResponse,
    GetClientsParams,
    GetClientsResponse,
    GetSendersSparkParams,
    GetSendersSparkResponse,
} from '@/new-services/types/orders'

type ApiGetClientsResponse = Promise<AxiosResponse<GetClientsResponse>>
type ApiGetCitiesResponse = Promise<AxiosResponse<GetCitiesResponse>>
type ApiGetSendersSparkResponse = Promise<AxiosResponse<GetSendersSparkResponse>>
type ApiDeleteSenderSparkResponse = Promise<AxiosResponse<void>>
type ApiCreateSenderSparkResponse = Promise<AxiosResponse<void>>
type ApiCreateOrderSparkResponse = Promise<AxiosResponse<void>>

export function getClients(params: GetClientsParams): ApiGetClientsResponse {
    return http.get('/order/api/v1/call-center/users', { params })
}

export function getSendersSpark(params: GetSendersSparkParams): ApiGetSendersSparkResponse {
    return http.get('/order/api/v1/call-center/sender-templates', { params })
}

export function deleteSenderSpark(id: number): ApiDeleteSenderSparkResponse {
    return http.delete(`/order/api/v1/call-center/sender-templates/${id}`)
}

export function createSenderSpark(params: CreateSenderSparkPayload): ApiCreateSenderSparkResponse {
    return http.post('/order/api/v1/call-center/sender-templates', params)
}

export function updateSenderSpark(
    id: number,
    payload: CreateSenderSparkPayload
): ApiDeleteSenderSparkResponse {
    return http.put(`/order/api/v1/call-center/sender-templates/${id}`, payload)
}

export function getCities(params: GetCitiesParams): ApiGetCitiesResponse {
    return http.get('/order/api/v1/cities', { params })
}

export function createOrderSpark(payload: FormData): ApiCreateOrderSparkResponse {
    return http.postFormData('/order/api/v2/call-center/orders/excel', payload)
}

export default {
    getClients,
    getSendersSpark,
    deleteSenderSpark,
    createSenderSpark,
    updateSenderSpark,
    getCities,
    createOrderSpark,
}
